import logo from './logo.svg';
import './App.css';
import Header from './template/Header';

function App() {
  return (
    <div>
      <Header />

      <div style={{
        textAlign: 'center',
        padding: 30
      }}>
        <div style={{
          fontSize: 46
        }}>Marketplace</div>
        <div style={{
          fontSize: 32
        }}>Templates para usar com nossas aplicações</div>
      </div>
    </div>
  );
}

export default App;
